import type { EditorTab } from '../HtmlEditor.types';

type LeftRailProps = {
  tab: EditorTab;
  onTabChange: (tab: EditorTab) => void;
  disabled?: boolean;
};

export function LeftRail({ tab, onTabChange, disabled }: LeftRailProps) {
  return (
    <nav className='ee-rail'>
      <button
        type='button'
        className={`ee-rail__btn ${tab === 'content' ? 'is-on' : ''}`}
        onClick={() => onTabChange('content')}
        disabled={disabled}
      >
        <span className='ee-rail__icon'>⊞</span>
        <span className='ee-rail__label'>Contenuto</span>
      </button>
      <button
        type='button'
        className={`ee-rail__btn ${tab === 'style' ? 'is-on' : ''}`}
        onClick={() => onTabChange('style')}
        disabled={disabled}
      >
        <span className='ee-rail__icon'>◐</span>
        <span className='ee-rail__label'>Stile</span>
      </button>
    </nav>
  );
}
